export const state = {
  serviceRendu: undefined,
  serviceRendus: [],
  communes: [],
  sousServiceRendu: undefined,
  sousServiceRendus: []
}